import { useNavigate } from "react-router";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import GetPrx from "../../hooks/fetch-hooks/get-prx-data/get-prx";
import { DRXTable } from "./components";
import { HorizontalTable } from "./components/drx-table/Horiztonal";
import { VerticalDRX } from "./components/drx-table/Vertical";
import { getDRXTableDataCategorically } from "../../utils/generateRows";
import { addDaystoStartDate, getStartDateEndDate } from "../../utils/getStartDateEndDate";
// import { AckoDRX } from "./components/drx-table/AckoDRX";
// import ackoContants from "./components/drx-table/acko-drx/constants";
// import { toast } from "react-toastify";
import { NameSelectorModal } from "./components/NameSelectorModal";

// `onBack` is optional. Without it "< Back" steps browser history, as it always has. The
// logistics Orders tab renders this page inside a modal over its own list and passes
// onBack to close that modal -- stepping history there would leave the Orders page.
function DrxPage({ onBack }) {
    const [searchParams] = useSearchParams();

    let isQuotation = false;
    if (window.location.pathname.endsWith('/quotation')) {
        isQuotation = true;
    }

    const { orderId } = useParams();
    const location = useNavigate();
    const { data: prescription } = GetPrx(orderId, isQuotation);
    const [prescriptionData, setPrescriptionData] = useState(null);
    const [splitNumber, setSplitNumber] = useState(1);
    const [downloadAllSmallDrx, setdownloadAllSmallDrx] = useState(null);
    const [downloadAllBigDrx, setdownloadAllBigDrx] = useState(null);
    // const [selectedAckoProduct, setSelectedAckoProduct] = useState(ackoContants.ACKO_PRODUCTS[0]);
    const [selectedDrxName, setSelectedDrxName] = useState(null);
    const [showNameModal, setShowNameModal] = useState(false);
    // eslint-disable-next-line
    const params = [];

    function flipDownloadSmallDrx() {
        if (downloadAllSmallDrx === null) setdownloadAllSmallDrx(true);
        else setdownloadAllSmallDrx((prevState) => !prevState);
    }

    function flipDownloadBigDrx() {
        if (downloadAllBigDrx === null) setdownloadAllBigDrx(true);
        else setdownloadAllBigDrx((prevState) => !prevState);
    }

    for (let entry of searchParams.entries()) {
        params.push(entry);
    }
    const query = params.length > 0

    const daysDifference = (startDate, endDate) => {
        let StartDate = new Date(startDate);
        let EndDate = new Date(endDate);

        let difference_time = EndDate.getTime() - StartDate.getTime();
        let difference_days = difference_time / (1000 * 3600 * 24);

        return difference_days + 1;
    };
    // +++++++++++++++++++++++++++++
    const generateSplit = (prescription) => {
        let dates = [];
        let StartDate = prescription?.startDate;
        let EndDate = prescription?.endDate;
        let duration = prescription?.noOfDays;
        let splitDuration = duration / splitNumber;

        for (let i = 0; i < splitNumber; i++) {
            if (i === splitNumber - 1) {
                dates.push({
                    StartDate: getStartDateEndDate(StartDate),
                    EndDate: getStartDateEndDate(EndDate),
                    Duration: daysDifference(
                        StartDate,
                        getStartDateEndDate(addDaystoStartDate(EndDate, 1))
                    ),
                });
            } else {
                dates.push({
                    StartDate: getStartDateEndDate(StartDate),
                    EndDate: getStartDateEndDate(
                        addDaystoStartDate(StartDate, splitDuration)
                    ),
                    Duration: daysDifference(
                        StartDate,
                        addDaystoStartDate(StartDate, splitDuration) + 1
                    ),
                });
            }

            StartDate = getStartDateEndDate(
                addDaystoStartDate(StartDate, splitDuration + 1)
            );
        }
        return dates;
    };



    function getData(data) {
        if (!prescription) {
            location(-1, { replace: true })
        }
        return getDRXTableDataCategorically(data)
    }

    React.useEffect(() => {
        if (prescription?.data) {
            let prescriptionValues = getData(prescription?.data?.data.prescription?.prescriptionItems);
            setPrescriptionData({
                    count: prescriptionValues?.rows?.length,
                    rows: prescription?.data?.data.prescription?.prescriptionItems,
                    startDate: prescription?.data?.data.prescription?.prescriptionItems[0]?.startDate,
                    endDate: prescription?.data?.data.prescription?.prescriptionItems[0]?.endDate,
                    drName: prescription?.data?.data.prescription?.drName,
                    patientName: prescription?.data?.data.mapUserPatient?.Patient?.name,
                    userName: prescription?.data?.data.mapUserPatient?.User?.name,
                    bill_no: prescription?.data?.data?.additionalDetails?.billNumber ?? null,
                    prescriptionValues
                });

            // if split is greater than 1 then split duration of prescription
            if (splitNumber > 1) {
                const days = prescription?.data?.data.data?.days;
                const splitDays = Math.ceil(days / splitNumber);
                const newEndDate = new Date(prescription?.data?.data.data?.startDate);
                newEndDate.setDate(newEndDate.getDate() + splitDays);
                setPrescriptionData({
                    ...prescriptionData,
                    endDate: newEndDate,
                });
            }
        }
    }, [prescription]);

    // const handleMedicineMappingSelect = (prxMedicine, ackoMedicine) => {
    //     if (!selectedAckoProduct || !prxMedicine || !ackoMedicine) {
    //         return toast.error("Invalid medicine/product")
    //     }

    //     setSelectedAckoProduct({
    //         ...selectedAckoProduct,
    //         [ackoMedicine]: {
    //             prxMedicine: prescriptionData?.prescriptionValues?.rows.find((row) => row.Medicine.name === prxMedicine),
    //         }
    //     })
    // }

    return (
        <div className="max-h-[85vh] overflow-y-auto overflow-x-hidden">
            <h2
                className="mb-2 cursor-pointer font-bold text-xl mt-3 p-2 text-[#28a48b]"
                onClick={() => {
                    if (onBack) onBack();
                    else location(-1);
                }}>
                {"<"} Back
            </h2>
            <div className="flex items-center gap-4  ml-5 mt-8">
                <h6 className="font-sans">Enter Split Count:</h6>
                <input
                    type="number"
                    className="border border-solid border-gray-400 rounded-2xl px-4 py-2 text-left w-20"
                    placeholder="Enter Split Number...."
                    onChange={(e) => { setSplitNumber(e.target.value); }}
                    value={splitNumber}
                />
                <button
                    onClick={() => { setdownloadAllBigDrx(true) }}
                    className="mt-6 mb-6 p-2 bg-[#28A48B] text-white font-semibold px-6 rounded-2xl"
                    style={{ color: "white", display: splitNumber > 0 ? 'block' : 'none' }}>
                    Download All Big DRX
                </button>
                <button
                    onClick={() => { setdownloadAllSmallDrx(true) }}
                    className="mt-6 mb-6 p-2 bg-[#28A48B] text-white font-semibold px-6 rounded-2xl"
                    style={{ color: "white", display: splitNumber > 0 ? 'block' : 'none' }}>
                    Download All Small DRX
                </button>
            </div>

            {!prescription?.data && prescription?.data?.length < 1 && (location(-1), { replace: true })}

            {prescriptionData && (
                <div className="ml-5 mb-4">
                    <button
                        onClick={() => setShowNameModal(true)}
                        className="p-2 bg-white border-2 border-[#28A48B] text-[#28A48B] font-semibold px-6 rounded-2xl hover:bg-[#e6f7f4]"
                    >
                        {selectedDrxName
                            ? `Name on DRX: ${selectedDrxName}`
                            : "Select Name for DRX"}
                    </button>
                </div>
            )}

            {showNameModal && (
                <NameSelectorModal
                    patientName={prescriptionData?.patientName}
                    userName={prescriptionData?.userName}
                    onConfirm={(name) => {
                        setSelectedDrxName(name);
                        setShowNameModal(false);
                    }}
                    onClose={() => setShowNameModal(false)}
                />
            )}

            {/* Main DRXS+++++++++++++ */}
            {prescriptionData?.count >= 0 && (<>
                {generateSplit(prescription?.data?.data).map((date, i) => (
                    <DRXTable {...prescriptionData} patientName={selectedDrxName ?? prescriptionData?.patientName} getDates={date} key={i} index={i} wbn={query} downloadAllBigDrx={downloadAllBigDrx} flipDownloadBigDrx={flipDownloadBigDrx} isQuotation={isQuotation} />
                ))}
            </>
            )}
            {prescriptionData?.count <= 7 && (<>
                {generateSplit(prescription?.data?.data).map((date, i) => (
                    <HorizontalTable {...prescriptionData} patientName={selectedDrxName ?? prescriptionData?.patientName} getDates={date} key={i} index={i} wbn={query} downloadAllSmallDrx={downloadAllSmallDrx} flipDownloadSmallDrx={flipDownloadSmallDrx} isQuotation={isQuotation} />
                ))}
            </>
            )}
            {prescriptionData?.count > 7 && (<>
                {generateSplit(prescription?.data?.data).map((date, i) => (
                    <VerticalDRX {...prescriptionData} patientName={selectedDrxName ?? prescriptionData?.patientName} getDates={date} key={i} index={i} wbn={query} downloadAllSmallDrx={downloadAllSmallDrx} flipDownloadSmallDrx={flipDownloadSmallDrx} isQuotation={isQuotation} />
                ))}
            </>
            )}
            {/* <>
                <h2 className="text-2xl font-bold text-gray-800 mb-4 ml-5">Acko DRX</h2>
                <select onChange={(e) => setSelectedAckoProduct(ackoContants.ACKO_PRODUCTS.find((product) => product.id === e.target.value))} className="border border-solid border-gray-400 rounded-2xl px-4 py-2 text-left ml-5 mb-4">
                    {ackoContants.ACKO_PRODUCTS.map((product) => (
                        <option key={product.name} value={product.id}>
                            {product.name}
                        </option>
                    ))}
                </select>
                <div className="flex gap-5" >
                    {generateSplit(prescription?.data?.data).map((date, i) => (
                        <AckoDRX {...prescriptionData} getDates={date} key={i} index={i} wbn={query} downloadAllSmallDrx={downloadAllSmallDrx} flipDownloadSmallDrx={flipDownloadSmallDrx} selectedAckoProduct={selectedAckoProduct} />
                    ))}
                    <div className="flex flex-col gap-4" >
                        {
                            ackoContants.ACKO_PRODUCTS.find((product) => product.id === selectedAckoProduct.id)?.medicines.map((ackoMedicine) => {
                                return <div key={ackoMedicine} className="flex flex-col gap-1" >
                                    <span className="text-gray-700 font-semibold mb-2 text-lg">{ackoMedicine}</span>
                                    <select onChange={(e) => handleMedicineMappingSelect(e.target.value, ackoMedicine)} >
                                        <option value="">Select PRX Medicine</option>
                                        {
                                            prescriptionData?.prescriptionValues?.rows.map((row) => {
                                                return <option key={row.Medicine.name} value={row.Medicine.name}>{row.Medicine.name}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            })
                        }
                    </div>
                </div>
            </> */}
        </div>
    );
}

DrxPage.propTypes = { onBack: PropTypes.func };

export { DrxPage };

